import React, { useEffect, useState } from "react";
import Chatheader from "../chatheader/chatheader";
import { useStateValue } from '../../../../stateprovider';
import "./help.css";
import { useNavigate } from "react-router-dom";

const HelpComp = () => {
    const [{ }, dispatch] = useStateValue();
    const navigate = useNavigate();
    const [text, settext] = useState("");

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: false
        });
        dispatch({
            type: "APP_ICON_STATE",
            appIconState: 3
        })
    }, []);

    const Button = [
        { text: "Chat with a customer care", url: "/medical-record" },
        { text: "About us", url: "/about" }
    ];

    return <div className="app_complaint app_extend">
        <Chatheader />
        <div className="app_feedback">
            <h2>Leave us a message</h2>
            <div className={text?.length >= 1 ? "app_textdive app_textdive_active" : "app_textdive"}>
                <textarea placeholder="Leave us a message"  onChange={e => settext(e.target.value)}>

                </textarea>
                <button>Submit</button>
            </div>
            <div className="app_feedback_button">
                {Button.map((b, index) => {
                    return <button key={index} onClick={() => navigate(b.url)} style={index === 0 ? {
                        background: "#01B6E2",
                        border: "1px solid #01B6E2"
                    } : {}}>
                        {b.text}
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 5L19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                })}
            </div>
        </div>
    </div>
}
export default HelpComp;